import ShopaholicCouponAdd from '../../../js/shopaholic-coupon/shopaholic-coupon-add';
import ShopaholicCouponRemove from '../../../js/shopaholic-coupon/shopaholic-coupon-remove';

export default new class Coupon {
  constructor() {
    this.obShopaholicCouponAdd = new ShopaholicCouponAdd();
    this.obShopaholicCouponRemove = new ShopaholicCouponRemove();
    this.couponWrapperClass = 'cart__coupon-input';
    this.sButtonClass = 'cart__coupon-btn';

    this.initAddCoupon();
  }

  initAddCoupon() {
    this.obShopaholicCouponAdd.setAjaxRequestCallback((obRequestData, obInput, obButton) => {
      obRequestData.complete = (data, textStatus, jqXHR) => { 
        this.obShopaholicCouponAdd.completeCallback({data, textStatus, jqXHR}, obInput, obButton);
        if (data.status !== false) {
          obButton.classList.remove(this.addButtonClass);
          obButton.classList.add(this.removeButtonClass);
          obInput.classList.add(this.filledClass);
          obButton.innerHTML = 'Купон применен'; 
        } else {
          this.errorHandler(data.message);
          obInput.focus();
        }
      };
      return obRequestData;
    });
    this.obShopaholicCouponAdd.init();
  }
}